import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get purchaseDebitNote
export const getPurchaseDebitNote = createAsyncThunk(
  "purchaseDebitNote/getPurchaseDebitNote",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseDebitNote({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseDebitNote
export const getAllPurchaseDebitNote = createAsyncThunk(
  "purchaseDebitNote/getAllPurchaseDebitNote",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseDebitNote();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseDebitNote/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseDebitNote/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseDebitNote/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseDebitNote({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPurchaseDebitNoteById = createAsyncThunk(
  "purchaseDebitNote/getPurchaseDebitNoteById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseDebitNoteById(id);

      if (data?.data.drCrNotesDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.drCrNotesDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, drCrNotesDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create purchaseDebitNote
export const createPurchaseDebitNote = createAsyncThunk(
  "purchaseDebitNote/createPurchaseDebitNote",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseInvoiceMain,
      drCrNotesDetails,

      drCrNotesPartyDetails,

      // invoiceNo,
      // refNo,
      voucherDateBs,
      voucherDate,
      narration,
      branch,
      termsOfPayment,

      deliveryDocNo,

      partyAccount,
      otherReferences,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        purchaseInvoiceMain,
        drCrNotesDetails,

        drCrNotesPartyDetails,

        noteType: "purchase_debit",
        // invoiceNo,
        // refNo,
        voucherDateBs,
        voucherDate,

        branch,
        termsOfPayment,

        deliveryDocNo,

        narration,

        partyAccount,
        otherReferences,
        termsOfDelivery,
        destination,
        deliveryThrough,
        deliveryDocNumber,
        find,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.createPurchaseDebitNote(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePurchaseDebitNote = createAsyncThunk(
  "purchaseDebitNote/updatePurchaseDebitNote",
  async (params, { rejectWithValue }) => {
    const { id, submitData } = params;
    const {
      salesOrder,
      indentNo,
      voucherDateBs,
      voucherDate,
      branch,
      drCrNotesPartyDetails,

      // yo field name mileko thiyena, fix bhayo hai
      documentsAttach,
      // refVoucher,
      drCrNotesDetails,
    } = submitData;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        branch,
        status: "approved",
        drCrNotesPartyDetails,

        voucherDateBs,
        voucherDate,
        // refVoucher,
        drCrNotesDetails,
      });
      const { data } = await API.updatePurchaseDebitNote(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
// get purchase invoice details
export const getPurchaseDebitNoteDetailsById = createAsyncThunk(
  "purchaseDebitNote/getPurchaseDebitNoteDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseDebitNoteDetailsById(id);

      if (data?.data.purchaseInvoiceDetail?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.purchaseInvoiceDetail.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, purchaseInvoiceDetail: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseDebitNote/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
